import { render, staticRenderFns } from "./postContent.vue?vue&type=template&id=39d2e87a&"
import script from "./postContent.vue?vue&type=script&lang=js&"
export * from "./postContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports